import { render, staticRenderFns } from "./NotAllowedPage.vue?vue&type=template&id=2e674ecf&"
import script from "./NotAllowedPage.vue?vue&type=script&lang=js&"
export * from "./NotAllowedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports